webpackJsonp([70144966829960],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
		return _react2.default.createElement(
			"div",
			{ className: "page-wrapper" },
			_react2.default.createElement(_reactHelmet2.default, { title: "Contact - My Awesome Site" }),
			_react2.default.createElement(
				"section",
				{ className: "contact-hero" },
				_react2.default.createElement(
					"h1",
					null,
					"Please don't contact us"
				)
			),
			_react2.default.createElement(
				"section",
				{ className: "page-inner" },
				_react2.default.createElement(
					"div",
					{ className: "container" },
					_react2.default.createElement(
						"div",
						{ className: "contact-left" },
						_react2.default.createElement(
							"h2",
							null,
							"We'd rather sleep"
						),
						_react2.default.createElement(
							"p",
							null,
							"Our days are jammed packed with naps, video games, long lunches, and a little actual work sprinkled in there somewhere. Our work is so optimized we can pack in some 8 hours of work into about 2 or 3 hours, then we get out there and live life with the rest of our day."
						),
						_react2.default.createElement(
							"p",
							null,
							"But if for some reason you got the impression that we are a compnay you want to work with, go right ahead and fill out this form."
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "contact-right" },
						_react2.default.createElement(
							"form",
							{ action: "", method: "get" },
							_react2.default.createElement(
								"fieldset",
								null,
								_react2.default.createElement(
									"div",
									{ className: "form-row" },
									_react2.default.createElement(
										"label",
										{ "for": "contact-name" },
										"Name"
									),
									_react2.default.createElement("input", { type: "text", id: "contact-name" })
								),
								_react2.default.createElement(
									"div",
									{ className: "form-row" },
									_react2.default.createElement(
										"label",
										{ "for": "contact-email" },
										"Email"
									),
									_react2.default.createElement("input", { type: "email", id: "contact-email" })
								),
								_react2.default.createElement(
									"div",
									{ className: "form-row" },
									_react2.default.createElement(
										"label",
										{ "for": "contact-message" },
										"Message"
									),
									_react2.default.createElement("textarea", { id: "contact-message" })
								),
								_react2.default.createElement(
									"div",
									{ className: "form-row webline" },
									_react2.default.createElement(
										"label",
										{ "for": "contact-website" },
										"Website"
									),
									_react2.default.createElement("input", { type: "text", id: "contact-website" })
								),
								_react2.default.createElement(
									"div",
									{ className: "form-row" },
									_react2.default.createElement("input", { type: "submit", id: "contact-submit", value: "Submit" })
								)
							)
						)
					)
				)
			)
		);
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-c3e098f9342e6f4626fc.js